import React from 'react';
import { CheckOutlineIcon } from '@fiverr-private/icons';
import { Container, Stack } from '@fiverr-private/layout_components';
import { theme } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';

interface PreviewItemSubServiceProps {
    name: string;
    className?: string;
}

export const PreviewItemSubService = ({ name, className }: PreviewItemSubServiceProps) => (
    <Stack gap="2" alignItems="center" overflowX="hidden" className={className}>
        <Stack flexShrink={0}>
            <CheckOutlineIcon size={16} color={theme.colors.grey_1100} />
        </Stack>
        <Container color="grey_1100">
            <Text size="b_md" color="inherit">
                {name}
            </Text>
        </Container>
    </Stack>
);
